module.exports = __webpack_public_path__ + "media/src/images/feature-bg-03-1c43490a74c8fa98c3146a33a3834bb9.png";